import { render } from "./DsaBlock.vue?vue&type=template&id=011a00cc"
import script from "./DsaBlock.vue?vue&type=script&lang=js"
export * from "./DsaBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/DsaBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "011a00cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('011a00cc', __exports__)) {
    api.reload('011a00cc', __exports__)
  }
  
  module.hot.accept("./DsaBlock.vue?vue&type=template&id=011a00cc", () => {
    api.rerender('011a00cc', render)
  })

}


export default __exports__